import { render } from "./CardSocialTraffic.vue?vue&type=template&id=b76ceb46"
const script = {}
script.render = render

export default script